import { ApiData, ApiDescription, RequestsMethod } from '../clientTypes';

export type MentorPerformanceBand = 'excellent' | 'good' | 'attention' | 'at_risk';

export type MentorPerformanceTone = 'good' | 'ok' | 'bad' | 'neutral';

export type MentorPerformanceDriverKey =
  | 'feedback_timeliness'
  | 'parent_rating'
  | 'student_rating'
  | 'ai_quality'
  | 'punctuality'
  | 'reliability'
  | 'session_length'
  | 'student_retention'
  | 'student_churn_risk'
  | 'nps'
  | 'admin_discipline'
  | 'flags'
  | 'mentor_changes'
  | 'course_completion'
  | 'admissions';

export type MentorPerformanceDriverDTO = {
  key: MentorPerformanceDriverKey;
  label: string;
  points: number;
  maxPoints: number;
  tone: MentorPerformanceTone;
  detail: string;
  sampleSize: number;
};

export type MentorPerformanceEvidenceDTO = {
  at?: string;
  title: string;
  detail?: string;
  tone: MentorPerformanceTone;
  sessionId?: string;
  enrollmentId?: string;
  studentId?: string;
};

export type MentorPerformanceMetricsDTO = {
  sessionsHeld: number;
  meetingsScheduled: number;
  activeStudents: number;
  studentsLost: number;
  feedbackOnTimePct?: number;
  feedbackMissing: number;
  parentRating?: number;
  studentRating?: number;
  aiQuality?: number;
  punctualityPct?: number;
  averageLateMinutes?: number;
  reliabilityIssues: number;
  averageBillableMinutes?: number;
  averageStudentChurn?: number;
  nps?: number;
  lateInvoices: number;
  rejectedReports: number;
  mentorChanges: number;
  coursesCompleted: number;
  coursesCancelled: number;
  admissionsAccepted: number;
  admissionsRejected: number;
  flagsRaised: number;
  flagImpact: number;
};

export type MentorPerformanceDTO = {
  mentorId: string;
  name: string;
  email: string;
  status?: string;
  score: number | null;
  band: MentorPerformanceBand | null;
  earnedPoints: number;
  availablePoints: number;
  metrics: MentorPerformanceMetricsDTO;
  drivers: MentorPerformanceDriverDTO[];
  strengths: string[];
  weaknesses: string[];
  evidence?: Record<MentorPerformanceDriverKey, MentorPerformanceEvidenceDTO[]>;
};

export type MentorPerformanceResponseDTO = {
  windowDays: number;
  generatedAt: string;
  mentors: MentorPerformanceDTO[];
};

export const getMentorPerformance: ApiDescription = {
  endpoint: '/admin/mentors/performance',
  method: RequestsMethod.Get,
};

export type GetMentorPerformance = ApiData<
  { days?: number; mentorId?: string },
  MentorPerformanceResponseDTO
>;
